import $http from "@/axios-instance";
import {defaultPayloadForm} from "@/servicios/productos/casFamily/state";

/**
 * Guardar familia.
 * @param payload
 * @autor Paul Valencia
 */
export async function saveFamily({state,commit,dispatch}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.post(`admin/cas_families`, payload);
        commit('changeStateModalForm', false);
        commit('setPayloadForm', defaultPayloadForm());
        dispatch('getFamilies', state.filter);
        this.$vue.$alertSuccess(response.data.message);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Obtener familias.
 *
 * @autor Paul Valencia
 * @param payload
 */
export async function getFamilies({commit},payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`admin/cas_families`, {params: {...payload}});
        commit('setCasFamilies',response.data.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Cambiar estado de una familia.
 *
 * @param id
 * @autor Paul Valencia
 * @returns void
 */
export async function changeStatusFamily(context, payload) {
    await $http.patch(`admin/cas_families/${payload.id}/change_status`,payload).then(async (response) => {
        this.$vue.$alertSuccess(response.data.message);
    }).catch(async (error) => {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    });
}

/**
 * Actualizar familia.
 * @param payload:
 * @autor Paul Valencia
 */
export async function updateFamily({state,commit,dispatch}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.put(`admin/cas_families_update`,payload);
        commit('changeStateModalForm', false);
        dispatch('getFamilies', state.filter);
        this.$vue.$alertSuccess(response.data.message);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}

/**
 * Obtener familias activas.
 *
 * @autor Paul Valencia
 * @param int exceptFamilyId
 * @param payload
 */
export async function getActivesFamilies({commit}, exceptFamilyId) {
    try {
        if (exceptFamilyId === undefined) {
            exceptFamilyId = null;
        }
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`list/cas_families`, { params: { except_family_id: exceptFamilyId } });
        commit('setListFamilies',response.data.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}
